import { render, staticRenderFns } from "./addHoliday.vue?vue&type=template&id=6d8c03b9&"
import script from "./addHoliday.vue?vue&type=script&lang=js&"
export * from "./addHoliday.vue?vue&type=script&lang=js&"
import style0 from "./addHoliday.vue?vue&type=style&index=0&id=6d8c03b9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports